import { App } from './app';
import { withProviders } from './app/providers';

export const RootApp = withProviders(App);
